import { Injectable } from '@angular/core';
import { ApplicationHttpClient } from 'app/application-http-client';
import { Observable } from 'rxjs';

import { FormAssignment } from '../models/form-assignment';
import { FullForm } from '../models/full-form';

@Injectable()
export class FormAssignmentService {
  // private instance variable to hold base url
  private apiUrl = '/forms/formAssignments';

  public add(formAssignment: FormAssignment, packets: Array<{ id: number; name: string }>): Observable<FormAssignment> {
    const body = {
      formAssignment: formAssignment,
      packets: packets.map(form => {
        return { key: form.id, value: form.name };
      })
    };
    return this.http.post(this.apiUrl, body);
  }

  public get(formAssignmentId: number): Observable<FullForm> {
    return this.http.get(`${this.apiUrl}/${formAssignmentId}`);
  }

  public getActives(configurationId: number, showQuickPrint: boolean = false): Observable<FormAssignment[]> {
    return this.http.get(`${this.apiUrl}/getActives/${configurationId}?showQuickPrint=${showQuickPrint}`);
  }

  public getAll(configurationId: number): Observable<FormAssignment[]> {
    return this.http.get(`${this.apiUrl}/getAll/${configurationId}`);
  }

  public update(formAssignment: FormAssignment, packets: Array<{ id: number; name: string }>): Observable<FormAssignment> {
    const body = {
      formAssignment: formAssignment,
      packets: packets.map(form => {
        return { key: form.id, value: form.name };
      })
    };
    return this.http.put(`${this.apiUrl}/${formAssignment.id}`, body);
  }

  constructor(private http: ApplicationHttpClient) {}
}
